import { useEffect, useState } from "react";
import Style from "./style.module.css";
import InnerLoader from "../../../../component/ui/loader/inner-loader";
import DataNotFound from "../../../../component/ui/loader/data-not-found";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import {
  Table,
  TableBody,
  TableBuildingTag,
  TableCard,
  TableCell,
  TableDepartmentTag,
  TableFilterReturn,
  TableHead,
  TableHeaderWrap,
  TableRow,
} from "../../../../component/table/table-layout";
import { TitleHeading } from "../../../../component/ui/layout";

const OfficeAssetCategoryList = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [lists, setList] = useState([]);
  // const [filterReturn, setFilterReturn] = useState([]);
  // const [tablePagination, setTablePagination] = useState({});
  // const [btnLoader, setBtnLoader] = useState(false);
  // const [tableHeaders, setTableHeaders] = useState([]);

  const apiCall = useApiCall();

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: `office-asset/summary/by-category`,
      });
      setList(res.data);
      // setBtnLoader(false);
      setIsLoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };


  return (
    <>
      <div className={Style.leaveMainPage}>
        <div className={Style.report_table__header}>
          <span className={Style.report_table__title}>
            <TitleHeading title={`Category Summary`} />
          </span>
        </div>

        <div className={Style.LeaveBody}>
          {isLoading ? (
            <InnerLoader />
          ) : !lists?.length ? (
            <DataNotFound title={"Data"} />
          ) : (
            <>
              <TableCard>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell header>
                        <div className="flex gap-4 items-center">
                          <span>Assets Type</span>
                        </div>
                      </TableCell>

                      <TableCell header>
                        <div className="flex gap-4 items-center">
                          <span>Count</span>
                        </div>
                      </TableCell>

                      <TableCell header>
                        <div className="flex gap-4 items-center">
                          <span>Total Repairs</span>
                        </div>
                      </TableCell>

                      <TableCell header>
                        <div className="flex gap-4 items-center">
                          <span>Total Repair Cost</span>
                        </div>
                      </TableCell>

                      <TableCell header>
                        <div className="flex gap-4 items-center">
                          <span>Avg Repairs/Asset</span>
                        </div>
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {lists?.map((eachList, index) => {
                      return (
                        <TableRow key={`${index}`}>
                          <TableCell sticky>
                            <div className={`${Style.tableActionArea} !gap-4`}>
                              <div className="flex gap-[10px]">
                                <div className="flex items-center gap-3">
                                  <div className="font-semibold text-[15px] leading-5">{eachList?.asset_type}</div>
                                </div>
                              </div>
                            </div>
                          </TableCell>

                          <TableCell>
                            {eachList?.count}
                          </TableCell>

                          <TableCell>
                            {eachList?.total_repairs}
                          </TableCell>

                          <TableCell>
                            {eachList?.cost}
                          </TableCell>

                          <TableCell>
                            {eachList?.avg_repairs_per_asset}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableCard>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default OfficeAssetCategoryList;
